import { CREATE_REFER_RULE_API_SLUG, DELETE_REFER_RULE_API_SLUG, GET_REFER_RULES_API_SLUG, REDEEM_REFER_RULE_API_SLUG, UPDATE_REFER_RULE_API_SLUG } from "../constants/Api_constants";
import { axiosSecureInstance } from "./axios";

const COMMON_ERROR_MESSAGE = "Something went wrong!";

export const getAllReferRules = async () => {
  try {
    const response = await axiosSecureInstance.get(GET_REFER_RULES_API_SLUG());
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || COMMON_ERROR_MESSAGE;
    throw new Error(errorMessage);
  }
};

export const createReferRule = async (data) => {
  try {
    const response = await axiosSecureInstance.post(CREATE_REFER_RULE_API_SLUG(), data);

    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || COMMON_ERROR_MESSAGE;
    throw new Error(errorMessage);
  }
};

export const updateReferRule = async (id, data) => {
  try {
    const response = await axiosSecureInstance.put(UPDATE_REFER_RULE_API_SLUG(id), data);

    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || COMMON_ERROR_MESSAGE;
    throw new Error(errorMessage);
  }
};

export const deleteReferRule = async (id) => {
  try {
    const response = await axiosSecureInstance.delete(DELETE_REFER_RULE_API_SLUG(id));

    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || COMMON_ERROR_MESSAGE;
    throw new Error(errorMessage);
  }
};

export const redeemReferRule = async (data) => {
  try {
    const response = await axiosSecureInstance.post(REDEEM_REFER_RULE_API_SLUG(), data);

    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || COMMON_ERROR_MESSAGE;
    throw new Error(errorMessage);
  }
};